import { usingGet } from '@ocean/api'

export const getDistanceCourses = () =>
  usingGet('Search/Library/DistanceCourses', { useProxy: true })
